import { render } from "./pedidoCard.vue?vue&type=template&id=337d5bde&scoped=true"
import script from "./pedidoCard.vue?vue&type=script&lang=js"
export * from "./pedidoCard.vue?vue&type=script&lang=js"

import "./pedidoCard.vue?vue&type=style&index=0&id=337d5bde&lang=css"
import "./pedidoCard.vue?vue&type=style&index=1&id=337d5bde&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-337d5bde"]])

export default __exports__